import Vue from "vue";
import VueRouter from "vue-router";

import NotFound from "@/views/NotFoundPage.vue";
import DashboardLayoutMod from "@/views/Layout/DashboardLayout.vue";
import LogoutPage from "@/views/Logout.vue";
import Home from "@/views/Home";
import Callback from "@/views/Callback";
import { login, logout, logoutClaveUnica, home } from "@/middleware/auth";
import NoPermission from "@/views/NoPermission";
import auth from "@/service/auth";
import store from "@/store/index";
import { appConfig } from "@/appConfig";
import NoExisteEnServel from "@/views/NoExisteEnServel";
import SinConexion from "@/views/SinConexion";
import Faq from "@/components/Ciudadano/Faq/Faq";
import ciudadanoMenu from "@/routes/module/ciudadanoMenu";
import registroHistoricoMenu from "@/routes/module/registroHistorico";
import partidoPoliticoMenu from "@/routes/module/partidoPoliticoMenu";
import module from "@/enums/module";
import action from "@/enums/action";

Vue.use(VueRouter);

const routes = [
  { path: "/oauth2", component: Callback },
  { path: "/login", beforeEnter: login, name: "login" },
  { path: "/logout", beforeEnter: logoutClaveUnica, component: LogoutPage },
  { path: "/auth/logout", beforeEnter: logout, component: LogoutPage },
  { path: "/auth/login", beforeEnter: logout, component: LogoutPage },
  { path: "/noexisteenservel", component: NoExisteEnServel },
  { path: "/sinconexion", component: SinConexion },
  {
    path: "/sinpermiso",
    name: "no-permiso",
    component: NoPermission,
    meta: { title: "Sin permisos" },
  },
  { path: "/", beforeEnter: home },
  {
    path: "/portal",
    component: DashboardLayoutMod,
    redirect: "/portal/inicio",
    meta: { requiresAuth: true },
    children: [
      {
        path: "inicio",
        name: "home",
        component: Home,
        meta: { requiresAuth: true, title: "Inicio" },
      },
      {
        path: "faq",
        name: "faq",
        component: Faq,
        meta: {
          module: module.CIUDADANOS_FAQ,
          action: [action.CONSULTAR],
          title: "Preguntas Frecuentes",
        },
      },
    ],
  },
  ciudadanoMenu,
  registroHistoricoMenu,
  partidoPoliticoMenu,
  { path: "*", component: NotFound },
];

const route = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  routes,
});

route.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.auth.isUserSignedIn()) {
      store.commit("setLoggedIn", false);
      next({ path: "/login", query: { redirect: to.fullPath } });
      return;
    } else {
      if (store.state.cognitoInfo === null) {
        store
          .dispatch("getUserInfo")
          .then(() => store.commit("setLoggedIn", true))
          .catch(() => {
            store.commit("setLoggedIn", false);
            next({ path: "/login", query: { redirect: to.fullPath } });
            return;
          });
      }
      next();
    }
  }
  next();
});

route.beforeEach(async (to, from, next) => {
  if (to.path === "/") {
    next();
    return;
  }

  if (to.matched.some((x) => x.meta.requiresAuth)) {
    try {
      const result = await appConfig.initApp(store);
      console.log(result);
      if (result === false) {
        next({ path: "/noexisteenservel" });
        return;
      }

      const roles = store.state.roles;
      if (
        to.meta.hasOwnProperty("module") &&
        to.meta.hasOwnProperty("action")
      ) {
        if (
          roles.module.some(
            (m) =>
              to.meta.module === m.modulocodigo &&
              to.meta.action.some((a) => m.accioncodigo === a)
          )
        ) {
          next();
          return;
        } else {
          next({ path: "/sinpermiso" });
          return;
        }
      }
    } catch (err) {
      console.error(err.stack);
      console.error(err);
      next({ path: "/sinconexion" });
      return;
    }
  }
  console.log(to.path);
  next();
});

export default route;
